/* ============================================================
   AWC — Product detail page behaviour
   Tabs, quantity stepper, and pack/variant selection wired to
   the Shopify product form.
   ============================================================ */
(function () {
  'use strict';

  // ---- Image gallery: click a thumbnail to swap the main image --------
  // Delegated on document so it works after the theme editor re-renders.
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest && e.target.closest('[data-thumb]');
    if (!thumb) return;
    var media = thumb.closest('.pdp-hero__media');
    var main = media && media.querySelector('[data-main-image]');
    if (!main) return;
    var full = thumb.getAttribute('data-full');
    if (full) {
      main.src = full;
      var srcset = thumb.getAttribute('data-srcset');
      if (srcset) main.srcset = srcset;
    }
    var alt = thumb.getAttribute('data-alt');
    if (alt !== null) main.alt = alt;
    media.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('active'); });
    thumb.classList.add('active');
  });

  // ---- Detail tabs ----------------------------------------------------
  document.querySelectorAll('[data-tab]').forEach(function (tab) {
    tab.addEventListener('click', function () {
      var target = tab.getAttribute('data-tab');
      var root = tab.closest('[data-details]') || document;
      root.querySelectorAll('[data-tab]').forEach(function (t) { t.classList.remove('active'); });
      root.querySelectorAll('[data-panel]').forEach(function (p) { p.classList.remove('active'); });
      tab.classList.add('active');
      var panel = root.querySelector('[data-panel="' + target + '"]');
      if (panel) panel.classList.add('active');
    });
  });

  // ---- Per-product-form controls --------------------------------------
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var qtyInput = form.querySelector('[data-qty-input]');
    var qtyDisplay = form.querySelector('[data-qty-display]');
    var variantInput = form.querySelector('[data-variant-id]');
    var priceEl = form.querySelector('[data-price]');
    var atcBtn = form.querySelector('[data-atc]');
    var atcLabel = form.querySelector('[data-atc-label]');

    // Quantity stepper
    form.querySelectorAll('[data-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.getAttribute('data-qty-step'), 10) || 0;
        var current = parseInt(qtyInput ? qtyInput.value : (qtyDisplay ? qtyDisplay.textContent : '1'), 10) || 1;
        var next = Math.max(1, current + step);
        if (qtyInput) qtyInput.value = next;
        if (qtyDisplay) qtyDisplay.textContent = next;
      });
    });

    // Pack / variant options
    var options = form.querySelectorAll('[data-variant-option]');
    options.forEach(function (opt) {
      opt.addEventListener('click', function () {
        options.forEach(function (o) { o.classList.remove('active'); });
        opt.classList.add('active');

        var id = opt.getAttribute('data-variant-option');
        var price = opt.getAttribute('data-variant-price');
        var available = opt.getAttribute('data-variant-available') === 'true';

        if (variantInput) variantInput.value = id;
        if (priceEl && price) priceEl.textContent = price;

        if (atcBtn) {
          atcBtn.disabled = !available;
          if (atcLabel) atcLabel.textContent = available ? atcBtn.getAttribute('data-label-add') : atcBtn.getAttribute('data-label-soldout');
        }
      });
    });
  });
})();
